import $ from 'jquery/dist/jquery.slim'
import polyfill from 'es-dynamic-polyfill'

import Router from './router'
import Transition from './transition'
import scrollTop from './scrollTop'
import scrollBlur from './scrollBlur'


console.log(
`Made by Pascal Klau
with 💕 and 🍕
© 2016
www.artofmyself.com`
);


// start Router on page load
polyfill({
    fills: 'fetch, Promise',
    options: 'gated',
    afterFill() {
        main()
    }
})

function main() {


    Router()
    scrollBlur()


    let app  = $('#app'),
        path = window.location.pathname;

    // start Router on nav click
    $('body').on('click', 'nav a', function(e) {
        e.preventDefault();

        let clicked = path.substr(0, path.lastIndexOf('/')) + $(this).attr('href'),
            title   = $(this).text();

        // remove and add current
        $('nav a').removeClass('is-current');
        $(this).addClass('is-current');



        // set url
        console.log(clicked);
        history.pushState(title, null, clicked)

        // page transitions
        Transition()

        scrollTop(400, () => {

            $('#nav-main').addClass('fade-color');
            $('#header, #content').removeClass('fade-in');
            //setTimeout(() => {
                $('.spinner').show();
            //}, 500)

        });

        document.getElementById('content').onCSSTransitionEnd(() => {
            Router(clicked);
        });

    });

}



// WEBPACK FOOTER //
// ./src/js/main.js